/** Site path prefix: /brl, /mxn, /jpy, or /cc. */
export function getBasename() {
  const { pathname } = window.location;
  if (pathname === '/cc' || pathname.startsWith('/cc/')) {
    return '/cc';
  }
  if (pathname === '/jpy' || pathname.startsWith('/jpy/')) {
    return '/jpy';
  }
  if (pathname === '/mxn' || pathname.startsWith('/mxn/')) {
    return '/mxn';
  }
  if (pathname === '/brl' || pathname.startsWith('/brl/')) {
    return '/brl';
  }
  if (process.env.REACT_APP_SITE_PREFIX) {
    const prefix = process.env.REACT_APP_SITE_PREFIX;
    return prefix.startsWith('/') ? prefix : `/${prefix}`;
  }
  return '/brl';
}

export function getApiBaseURL() {
  return `${getBasename()}/api`;
}

export function getDefaultMerchantName() {
  const base = getBasename();
  if (base === '/cc') return 'Card Payment';
  if (base === '/mxn') return 'Mexico Payment';
  if (base === '/jpy') return 'Japan Payment';
  return 'Brazil Payment';
}

export function getResultPageURL() {
  if (typeof window === 'undefined') {
    return '';
  }
  return `${window.location.origin}${getBasename()}/pay/result`;
}

export function getNotifyURL() {
  if (typeof window === 'undefined') {
    return '';
  }
  return `${window.location.origin}${getBasename()}/api/notify`;
}
